import React, { useEffect, useRef, useState } from "react";
import classes from "./Quiz.module.scss";
import Header from "../../molecules/header/Header";
import TopHeader from "../../organism/top-header/TopHeader";
import PointHeader from "../../organism/point-header/PointHeader";
import QuizCard from "../../organism/quiz-card/QuizCard";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import TeacherComment from "../../molecules/teacher-commnet/TeacherComment";
import rabbitNormal from "../../static/images/rabbit-normal.png";
import badgePerfectText from "../../static/images/badgePerfectText.png";
import { fetchUsersQuiz } from "../../api/UsersQuizApi";
import { fetchUsersBadge } from "../../api/UsersBadgeApi";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { fetchUser } from "../../api/UsersApi";
import { selectQuizAtom } from "../../atoms/quiz/Quiz";

const Quiz = () => {
  const [mode, setMode] = useState<"education" | "financial">("financial");
  const quizApi = fetchUsersQuiz();
  const badgeApi = fetchUsersBadge();
  const navigate = useNavigate();
  const [selectQuiz, setSelectQuiz] = useAtom(selectQuizAtom);
  const [totalBadgeNo, setTotalBadgeNo] = useState(0);
  const [acquiredBadgeNo, setAcquiredBadgeNo] = useState(0);
  const userApi = fetchUser();

  // 横スクロール領域
  const outerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    quizApi.fetch({ quizClassification: mode });
  }, [mode]);

  useEffect(() => {
    badgeApi.fetch({ isCompleted: false });
    userApi.fetch();
  }, []);

  useEffect(() => {
    const data = badgeApi.state?.data?.[0];
    if (!data) return;
    setTotalBadgeNo(data.badgeList.length);
    const acquired = data.badgeList.filter(
      (d) => d.acquiredBadgeType != null && d.acquiredBadgeType !== ""
    );
    setAcquiredBadgeNo(acquired.length);
  });

  const getModeStyle = (type: "education" | "financial") =>
    type === mode
      ? { borderBottom: "solid 3px #008E7E", fontWeight: "700" }
      : undefined;

  const clickQuiz = (quizId: string) => {
    const usersQuiz = quizApi.state?.data?.[0].quizList.find((d) => d.quizId === quizId);
    const usersBadge = badgeApi.state?.data?.[0].badgeList.find((d) => d.quizId === quizId);
    if (!usersQuiz || !usersBadge) return;

    setSelectQuiz({
      quizId: usersQuiz.quizId,
      tag: usersQuiz.classificationName,
      title: usersQuiz.title,
      image: usersBadge.badgeImageData,
    });
    navigate("/quiz-contents");
  };

  // 1ページ送り（見た目が崩れにくい計算）
  const pageScroll = (dir: "prev" | "next") => {
    const outer = outerRef.current;
    if (!outer) return;
    const itemW = 64 + 8; // 画像幅64 + gap相当
    const page = Math.max(itemW, Math.floor(outer.clientWidth / itemW) * itemW);
    outer.scrollBy({ left: dir === "next" ? page : -page, behavior: "smooth" });
  };

  return (
    <>
      <div className={classes.container}>
        <Header />
        <TopHeader currentMenuUrl="/quiz" />
        <PointHeader aquiredPoint={userApi.state?.data?.[0]?.currentPoint ?? 0} />

        <div className={classes.comment}>
          <TeacherComment
            image={rabbitNormal}
            bgWhite={true}
            comment={[
              "ファイナンシャルプランナーや子育ての専門家とつくったオリジナルクイズです。",
              "1問正解するごとに100ptゲットできます♪",
            ]}
          />
        </div>

        <div className={classes.badgeContents}>
          <div className={classes.header}>
            <img src={badgePerfectText} alt="" />
          </div>

          {/* 横スクロール + 左右ボタン */}
          <div className={classes.badgeScroller}>
            <button
              type="button"
              aria-label="prev"
              className={classes.navBtn}
              onClick={() => pageScroll("prev")}
            >
              ‹
            </button>

            <div
              className={`${classes.badgeListOuter} hideScrollbar`}
              id="badgeListOuter"
              ref={outerRef}
            >
              <div className={classes.badgeList} id="badgeList">
                {badgeApi.state?.data?.[0].badgeList.map((d) => (
                  <img
                    className={classes.badge}
                    key={d.quizId}
                    src={d.badgeImageData}
                    alt={d.badgeImageData}
                  />
                ))}
              </div>
            </div>

            <button
              type="button"
              aria-label="next"
              className={classes.navBtn}
              onClick={() => pageScroll("next")}
            >
              ›
            </button>
          </div>

          <div className={classes.footer}>
            <div className={classes.correctNumber}>
              <span className={classes.strong}>{acquiredBadgeNo}</span>/全{totalBadgeNo}クイズ
            </div>
            <div className={classes.button}>
              <SimpleButton
                label="バッジ一覧"
                width="50%"
                color="orange"
                isRadius={true}
                onClick={() => navigate("/badge-list")}
              />
            </div>
          </div>
        </div>
        <div className={classes.quizContents}>
          <div className={classes.header}>
            <div
              className={classes.block}
              style={getModeStyle("financial")}
              onClick={() => setMode("financial")}
            >
              お金
            </div>
            <div
              className={classes.block}
              style={getModeStyle("education")}
              onClick={() => setMode("education")}
            >
              子育て
            </div>
          </div>

          {quizApi.state?.data?.[0].quizList.map((d, index) => (
            <div className={classes.quizBlock} key={index} onClick={() => clickQuiz(d.quizId)}>
              <QuizCard
                summary={d.explanation}
                tag={d.categoryName}
                imageData={d.image}
                internalUrl={""}
                index={index}
                done={d.completedDate != null && d.completedDate !== ""}
                correctNo={d.totalCorrectNumber}
              />
            </div>
          ))}
        </div>

        <BreadCrumb
          data={[
            { displayName: "みらいいコンシェル", url: "/top" },
            { displayName: "⚪︎×クイズ一覧" },
          ]}
        />
      </div>
    </>
  );
};

export default Quiz;
